import { inject } from 'aurelia';
import { IHttpClient } from '@aurelia/fetch-client';
import { ApiBase } from '../api-base';

@inject(IHttpClient)
export class PasskeyApi extends ApiBase {
    private readonly _base = 'api/auth/passkey';

    constructor(http: IHttpClient) {
        super(http);
    }

    public registerBegin(): Promise<any> {
        return this.post(`${this._base}/register/begin`, {})
            .then(r => r.content);
    }

    public registerComplete(attestation: any): Promise<any> {
        return this.post(`${this._base}/register/complete`, attestation)
            .then(r => r.content);
    }

    public loginBegin(email: string): Promise<any> {
        return this.post(`${this._base}/login/begin`, { email })
            .then(r => r.content);
    }

    public loginComplete(assertion: any): Promise<any> {
        return this.post(`${this._base}/login/complete`, assertion)
            .then(r => r.content);
    }
}
